export default __webpack_public_path__ + "static/media/linus3.ef5a33f4.webp";